<template>
  <div class="content">
    <List v-bind="$attrs"/>
    <Describe v-bind="$attrs"/>
  </div>
</template>

<script>
import List from './components/list'
import Describe from './components/describe'
export default {
  name: 'Content',
  components: {
    List,
    Describe
  }
}
</script>

<style scoped>
  html * {
    box-sizing: content-box;
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0px;
    overflow: hidden;
  }
  @media screen and (max-width:1920px) {
    .content {
      width: 1200px;
      margin: 0 auto;
      padding: 40px 0px;
      overflow: hidden;
    }
  }
  @media screen and (max-width:1200px) {
    .content {
      width: 90%;
      margin: 0 auto;
      padding: 40px 0px;
      overflow: hidden;
    }
  }
  @media screen and (max-width:992px) {
    .content {
      width: 90%;
      margin: 0 auto;
      padding: 40px 0px;
      overflow: hidden;
    }  }
  @media screen and (max-width:768px) {
    .content {
      width: 90%;
      margin: 0 auto;
      padding: 40px 0px;
      overflow: hidden;
    }
  }
</style>
